/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChangeKind = {
    Added: 'ADDED',
    Removed: 'REMOVED',
    Changed: 'CHANGED'
} as const;
export type ChangeKind = typeof ChangeKind[keyof typeof ChangeKind];


export function instanceOfChangeKind(value: any): boolean {
    for (const key in ChangeKind) {
        if (Object.prototype.hasOwnProperty.call(ChangeKind, key)) {
            if (ChangeKind[key as keyof typeof ChangeKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChangeKindFromJSON(json: any): ChangeKind {
    return ChangeKindFromJSONTyped(json, false);
}

export function ChangeKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeKind {
    return json as ChangeKind;
}

export function ChangeKindToJSON(value?: ChangeKind | null): any {
    return value as any;
}

export function ChangeKindToJSONTyped(value: any, ignoreDiscriminator: boolean): ChangeKind {
    return value as ChangeKind;
}

